import { useEffect, useState } from "react";
import { getMyAttendanceApi } from "../../app/api";

export default function MyAttendance() {


  // const IMAGE_BASE_URL = "https://uptask.visiontrek.io";

  
  // const [imagePreview, setImagePreview] = useState(null);
  const formatMinutes = (min) => {
    if (min === null || min === undefined) return "0m";
    return `${min}m`;
  };
  
  const formatDate = (date) =>
  typeof date === "string" ? date.split("T")[0] : "--";
  // const [records, setRecords] = useState([]);
  // const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   getMyAttendanceApi().then((res) => {
  //     if (res.success && Array.isArray(res.data)) {
  //       setRecords(res.data);
  //     }
  //     setLoading(false);
  //   });
  // }, []);

  // if (loading)
  //   return (
  //     <div className="p-6 text-center text-gray-600">
  //       Loading attendance...
  //     </div>
  //   );











  //   const [page, setPage] = useState(1);
  //   const recordsPerPage = 5; // change if needed
    
  //   const totalPages = Math.ceil(records.length / recordsPerPage);
    
  //   const startIndex = (page - 1) * recordsPerPage;
  //   const paginatedRecords = records.slice(
  //     startIndex,
  //     startIndex + recordsPerPage
  //   );
    


  //   useEffect(() => {
  //     if (page > totalPages) {
  //       setPage(1);
  //     }
  //   }, [records]);
    

  // export default function MyAttendance() {

    const IMAGE_BASE_URL = "https://uptask.visiontrek.io";
  
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(true);
    const [imagePreview, setImagePreview] = useState(null);
  
    // ✅ Pagination state MUST BE HERE
    const [page, setPage] = useState(1);
    const recordsPerPage = 5;
  
    useEffect(() => {
      getMyAttendanceApi().then((res) => {
        if (res.success && Array.isArray(res.data)) {
          setRecords(res.data);
        }
        setLoading(false);
      });
    }, []);
  
    const totalPages = Math.ceil(records.length / recordsPerPage);
    const startIndex = (page - 1) * recordsPerPage;
    const paginatedRecords = records.slice(
      startIndex,
      startIndex + recordsPerPage
    );
  
    // ✅ This useEffect must also be ABOVE return
    useEffect(() => {
      if (page > totalPages) {
        setPage(1);
      }
    }, [records]);
  
    // ✅ NOW conditional return is OK
    if (loading) {
      return (
        <div className="p-6 text-center text-gray-600">
          Loading attendance...
        </div>
      );
    }
  

  return (
    <>
 
    
     {/* <div className="min-h-screen  px-2 py-4 sm:p-6 justify-center  flex ml-0 "> */}
 

    {/* FIXED WIDTH OUTER CARD (same as Winners UI) */}
    <div className="
        rounded-2xl p-3 md:p-5
        bg-[#12082F] border border-white/10
        text-white shadow-2xl  mt-4
      ">

        {/* Header */}
        <div className="flex  flex-col justify-between items-start mb-3 gap-2">
          <h2 className="font-semibold text-base md:text-xl">
          My Attendance
          </h2>
      </div>


        {/* TABLE WRAPPER — horizontal scroll on mobile */}

                          {/* <div className="overflow-x-auto">
          <table className="min-w-[750px] w-full border-collapse text-sm md:text-base shadow-md">
            <thead className="bg-[#f3f4f6]">
              <tr className="text-left shadow-lg text-sm"> */}
                 <div className="overflow-x-auto rounded-2xl bg-white/5 backdrop-blur">
            <table className="min-w-[1000px] w-full text-sm text-white ">
              <thead>
                <tr className="text-left text-gray-300 border-b border-white/10">
                <th className="p-4">Employee</th>
                <th className="p-4">Date</th>
                <th className="p-3">Punch In</th>

    <th className="p-3"> Img In</th>   {/* ✅ NEW */}
                <th className="p-3"> Img Out</th>  {/* ✅ NEW */}
                <th className="p-3">Punch Out</th>
                <th className="p-3">Total Hours</th>
                <th className="p-3">Break</th>
                <th className="p-3">Status</th>
                <th className="p-3">Early / Extra</th>
              </tr>
            </thead>

            {/* TABLE BODY */}
            <tbody>
            {paginatedRecords.length > 0 ? (
  paginatedRecords.map((row, i) => (

                  <tr key={i} className="border-b border-white/5 hover:bg-white/10 transition">
                    <td className="p-3 font-medium">
                      {row.name || [row.first_name, row.last_name].filter(Boolean).join(" ") || "—"}
                      {row.emp_id ? (
                        <span className="block text-xs text-white/50">{row.emp_id}</span>
                      ) : null}
                    </td>

                    {/* <td className="p-3">
                      {new Date(row.attendance_date).toLocaleDateString()}
                    </td> */}
                    <td>{formatDate(row.attendance_date)}</td>

                    <td className="p-3">{row.punch_in || "—"}</td>

                    <td className="p-3 text-center">
  {row.punch_in_img ? (
    <img
      src={`${IMAGE_BASE_URL}/${row.punch_in_img}`}
      alt="Punch In"
      className="w-10 h-10 object-cover rounded cursor-pointer border"
      onClick={() =>
        setImagePreview(`${IMAGE_BASE_URL}/${row.punch_in_img}`)
      }
    />
  ) : (
    "—"
  )}
</td>



<td className="p-3 text-center">
  {row.punch_out_img ? (
    <img
      src={`${IMAGE_BASE_URL}/${row.punch_out_img}`}
      alt="Punch Out"
      className="w-10 h-10 object-cover rounded cursor-pointer border"
      onClick={() =>
        setImagePreview(`${IMAGE_BASE_URL}/${row.punch_out_img}`)
      }
    />
  ) : (
    "—"
  )}
</td>








                    <td className="p-3">{row.punch_out || "—"}</td>
                    {/* <td className="p-3">{row.total_hours || "—"}</td> */}
                    <td className="p-3 text-sm">
                        {row.total_minutes
                          ? `${Math.floor(row.total_minutes / 60)}h ${row.total_minutes % 60}m`
                          : "—"}
                      </td>



                    {/* <td className="p-3">{row.break_minutes || "0m"}</td> */}
                    <td className="p-3">{formatMinutes(row.break_minutes)}</td>

              

                    <td className="p-3">
                      <span
                        className={`
                          px-3 py-1 rounded-full text-xs font-semibold
                          ${
                            row.status === 1
                              ? "bg-green-100 text-green-700"
                              : row.status === 0
                              ? "bg-red-100 text-red-700"
                              : "bg-yellow-100 text-yellow-700"
                          }
                        `}
                      >
                        {row.status === 1
                          ? "Present"
                          : row.status === 0
                          ? "Absent"
                          : "—"}
                      </span>
                    </td>

                    <td className="p-3 text-xs text-gray-200">
                      Early: {row.early_time || "0m"} <br />
                      Extra: {row.extra_time || "0m"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                 <td colSpan="9" className="p-4 text-center text-gray-500">
                    No Attendance Records Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      <div className="flex justify-between mt-4 text-sm">
  <div className="opacity-70">
    Page {page} of {totalPages || 1}
  </div>

  <div className="flex gap-2">
    <button
      disabled={page === 1}
      onClick={() => setPage((p) => p - 1)}
      className="px-3 py-1 rounded bg-white/10 disabled:opacity-40"
    >
      Prev
    </button>

    <button
      disabled={page === totalPages}
      onClick={() => setPage((p) => p + 1)}
      className="px-3 py-1 rounded bg-purple-600 disabled:opacity-40"
    >
      Next
    </button>
  </div>
</div>

      </div>
      {/* </div> */}





      {/* IMAGE PREVIEW MODAL */}
{imagePreview && (
  <div
    className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center"
    onClick={() => setImagePreview(null)}
  >
    <div
      className="bg-white p-4 rounded-xl max-w-[90%] max-h-[90%]"
      onClick={(e) => e.stopPropagation()} // prevent close on image click
    >
      <img
        src={imagePreview}
        alt="Attendance"
        className="max-w-full max-h-[80vh] rounded"
      />
    </div>
  </div>
)}

      </>
  );
}
